import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDestination = (props) => /* @__PURE__ */ _jsx("svg", {
	fill: "none",
	height: 41,
	viewBox: "0 0 41 41",
	width: 41,
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "m20.2803 4.04004c-3.214 0-6.3557.95304-9.028 2.73862-2.67234 1.78557-4.75514 4.32344-5.98506 7.29274-1.22993 2.9693-1.55173 6.2367-.92472 9.3889.62701 3.1521 2.17467 6.0476 4.44727 8.3202 2.27261 2.2726 5.16811 3.8203 8.32031 4.4473s6.4195.3052 9.3888-.9247 5.5072-3.3128 7.2928-5.985c1.7855-2.6723 2.7386-5.8141 2.7386-9.0281-.0046-4.3083-1.7181-8.4389-4.7646-11.48542-3.0464-3.04648-7.1771-4.75999-11.4854-4.76454zm5 20.62496c0 .1658-.0659.3248-.1831.442s-.2762.183-.4419.183h-8.75c-.1658 0-.3248-.0658-.442-.183s-.183-.2762-.183-.442v-8.75c0-.1657.0658-.3247.183-.4419s.2762-.1831.442-.1831h8.75c.1657 0 .3247.0659.4419.1831s.1831.2762.1831.4419z",
		fill: "#fbb243"
	})
});
export default SvgDestination;
